import { Box, Typography } from "@mui/material";

export default function Badge(props) {
  const textColor = props.color || "#fff";

  const badgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "8px",
    gap: "6px",
    padding: "4px 8px",
    backgroundColor: props.bgColor || "var(--primary-color)",
    color: props.color || "#fff",
    ...props.sx,
  };

  return (
    <Box {...props} sx={{ ...badgeStyle }}>
      {props.icon}
      {props?.text ? (
        props.text
      ) : (
        <Typography
          variant={props.textVariant || "h6"}
          {...props.textProps}
          sx={{
            color: textColor,
            fontSize: "16px",
          }}
        >
          {props.label || ""}
        </Typography>
      )}
    </Box>
  );
}
